/* istanbul ignore file */
/**
 * @var string COOKIEに保存するAPI_KEY,SECRETのキー名
 */
export const COOKIE_KEY_SESSION = 'fl-nextjs-session'

/**
 * @var string COOKIEに保存するJWTアクセストークンのキー名
 */
export const COOKIE_KEY_SESSION_JWT = 'fl-nextjs-session-token'

/**
 * @var string COOKIEに保存するリフレッシュトークンのキー名
 */
export const COOKIE_KEY_SESSION_REFRESH = 'fl-nextjs-session-refresh'

/**
 * @var string COOKIEのPHPのセッションキー名
 */
export const COOKIE_KEY_PHP_SESSION = 'PHPSESSID'

/**
 * @var string COOKIEのURL配布型ユーザー判定のためのキー名
 */
export const COOKIE_KEY_LIMITED_URL = 'limitd_url_key'

/**
 * @var string /apiへのリクエストを旧フロントと新フロントで分けるためのカスタムヘッダー
 */
export const CUSTOM_HEADER_FLIER_APP_KEY = 'FLIER-APP'
export const CUSTOM_HEADER_FLIER_APP_VALUE = 'Nextjs'
export const CUSTOM_HEADER_FLIER_APP = {
  [CUSTOM_HEADER_FLIER_APP_KEY]: CUSTOM_HEADER_FLIER_APP_VALUE,
}

/**
 * @var Record 退会理由の一覧
 */
export const WITHDRAW_REASONS = {
  '01': '月額の利用料金が高かった',
  '02': '要約の内容がつまらなかった',
  '03': '読みたい要約がなかった',
  '04': '読みたい要約を読み終えた',
  '05': '要約を読む時間がなかった',
  '06': '要約では効果がないと感じた',
  '07': 'サイトの更新が少なかった',
  '08': 'サイトが使いにくかった',
  '09': '他社の類似サービスを利用することにした',
  '99': 'その他（コメント欄に詳細をご記入ください）',
}

/**
 * docomo決済用のサイトID
 */
export const SP_GOLD_SITE_ID = '00073476804'
export const SP_SILVER_SITE_ID = '00073476802'

/**
 * シルバー会員の上限冊数
 */
export const SILVER_MAX_BOOK_COUNT = 5
